{{if bankInfo.BankBindStatus==1}}
<div class="tixian-con clearfix">
    <ul class="fl" style="width:58%">
        <li class="cardNo">银行卡：<h3>{{bankInfo.BankInfo.BankName}} ({{bankInfo.BankInfo.BankCardNum}})</h3></li>
        <li class="tixian-amount">
            <span>提现金额：</span><span style="font-size: 50px;">￥</span><input type="text" class="tixianAmount" placeholder="请输入提现金额" oninput="value=value.replace(/[^\d]/g,'')">
        </li>
        <li class="card-yue">您的收入账户金额：<h4>{{bankInfo.TotalCanUseCash}}元</h4>   <span id="txdes" style="cursor: pointer;">提现说明?</span></li>
    </ul>
    <a class="tixian-btn fr" id="tixianBtn">提现<a>
</div>
<!--
<div class="detail-con">
    <h3 class="detail-title">提现明细</h3>
    <div id="tixiandetail-con"></div>
</div>
-->
{{else}}
<div class="tixian-con clearfix">
    <ul class="fl" style="width:58%">
        <li class="cardNo">银行卡：<h3>还没绑定银行卡</h3></li>
        <li class="tixian-amount">
            <span>提现金额：</span><span style="font-size: 50px;">￥</span><input type="text" class="tixianAmount" placeholder="请输入提现金额" oninput="value=value.replace(/[^\d]/g,'')">
        </li>
        <li class="card-yue">您的收入账户金额：<h4>{{bankInfo.TotalCanUseCash}}元</h4>   <span id="txdes" style="cursor: pointer;">提现说明?</span></li>
    </ul>
    <a class="bind-btn fr" id="bindBtn">绑定银行卡<a>
</div>
{{/if}}
